import { render, staticRenderFns } from "./kbiz-account-modal.vue?vue&type=template&id=67b75670&scoped=true&"
import script from "./kbiz-account-modal.vue?vue&type=script&lang=js&"
export * from "./kbiz-account-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b75670",
  null
  
)

export default component.exports